import React, { useState, useEffect } from 'react';
import { SkipForward } from 'lucide-react';
import {
  Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle, DialogDescription,
  Button, ICON_PX,
} from '../ui';

function SkipReasonModal({ open, onOpenChange, task, onSkip }) {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  if (!task) return null;

  const handleSubmit = () => {
    onSkip?.(task.id, reason);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Skip Task</DialogTitle>
          <DialogDescription>{task.taskName || task.name}</DialogDescription>
        </DialogHeader>

        <div className="space-y-3 px-6 py-3">
          <p className="text-body-sm text-text-muted">
            Skipped tasks are logged separately from completions and will not count toward your completion rate.
          </p>
          <div>
            <label className="block text-body-sm font-medium text-text-secondary mb-1">
              Reason <span className="text-red-500">*</span>
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Why is this task being skipped?"
              rows={3}
              className="w-full rounded-md border border-nn-border bg-nn-white px-3 py-2 text-body text-text-dark focus:outline-none focus:ring-2 focus:ring-aqua/40 resize-none"
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button size="sm" variant="danger" disabled={!reason.trim()} onClick={handleSubmit}>
            <SkipForward size={ICON_PX.md} className="mr-1" /> Skip Task
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default SkipReasonModal;
